package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GET_BUSINESS_CATEGORIES
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class GetBusinessCategoriesRequestModel : BaseRequestModel(api = GET_BUSINESS_CATEGORIES)

